export default API => ({
    // 培训机构入驻
    branchApply(data) {
        return API({
            url: `/usercenter/v1/branchApplyRecord/save`,
            method: 'post',
            data
        });
    }
})
